<nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a (click)="toggleSidebar()" class="nav-link" data-widget="pushmenu" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a routerLinkActive="list-item-active" routerLink="/customerDashboard" class="nav-link">Home</a>
      </li>
      <li *ngIf="router !== '/salestax'" class="nav-item d-none d-sm-inline-block">
        <a routerLinkActive="list-item-active" routerLink="/crprogram" class="nav-link">CR Program</a>
      </li>
      <li *ngIf="router === '/salestax'" class="nav-item d-none d-sm-inline-block">
        <a routerLinkActive="list-item-active" routerLink="/salestax" class="nav-link">Sales Tax Configuration</a>
      </li>
      <!-- <li class="nav-item d-none d-sm-inline-block" style="float:left">
        
      </li> -->
    </ul>   
    <div class="ml-auto d-flex">
      <span class="align-self-center mr-2"><b>{{Name}}</b></span>
      <button (click)="logout()" class="nav-link btn btn-sm btn-blue px-2 mr-3">Logout</button>
    </div>
    
    <!-- Right navbar links -->

  </nav>